module.exports = __webpack_public_path__ + "img/li.li1211606.svg";